// @flow-strict

/* eslint-disable camelcase */
// import system = require("durandal/system");
// import app = require("durandal/app");
// import {array} from "shared/utils";
// import FB = require("shared/services/facebook");

import isPromise from 'is-promise';
import * as FB from './sharedService';
import { facebookpagesInstall, facebookpagesUninstall } from './merchantService';
import { FB_APP_ID } from '/client/src/constants';

export const states = {
  sdk_error: 1,
  not_login: 2,
  not_permission: 3,
  success: 4
};

/**
 * Initialize facebook sdk
 */
export const init = FB.init;
/**
 * Log In
 */
export function fbLogin() {
  return new Promise((resolve, reject) => {
    FB.fbSdk.login((response) => {
      if (response.status === 'connected') {
        // login successful
        resolve(response);
      } else {
        // Cancel login
        reject(states.not_login);
      }
    }, { scope: 'email,pages_manage_metadata' });  // manage_pages DEPRICATED
  });
}

export function logout() {
  return new Promise((resolve) => {
    getLoginStatus().then(() => {
      FB.fbSdk.logout(() => {
        resolve();
      });
    }).catch(() => {
      resolve();
    });
  });
}

export function disconnect() {
  return new Promise((resolve) => {
    getLoginStatus().then(() => {
      FB.fbSdk.api('/me/permissions', 'DELETE', (res) => {
        if (res.success) {
          console.log('app deauthorized');
          resolve();
        } else if (res.error) {
          console.error(`${res.error.type  }: ${  res.error.message}`);
        } else {
          console.log(res);
        }
      });
    }).catch(() => {
      resolve();
    });
  });
}

let facebook_user;
/**
 * Get current user information
 */

export function me() {
  if (isPromise(facebook_user)) {
    return facebook_user;
  }

  facebook_user = new Promise((resolve) => {
    if (facebook_user) {
      resolve(facebook_user);
    }

    FB.fbSdk.api('/me?fields=id,name,email', response => {
      facebook_user = response;

      resolve(response);
    });
  }).then((user) => {
    facebook_user = user;

    return user;
  });

  return facebook_user;
}

export function getAccessToken() {
  return FB.fbSdk.getAccessToken();
}

/**
 * Get login status
 */
export function getLoginStatus() {
  return new Promise((resolve, reject) => {
    FB.fbSdk.getLoginStatus((response) => {
      if (response.status === 'connected') {
        resolve();
      } else {
        reject(states.not_login);
      }
    });
  });
}

/**
 * Verify if you have permission
 */
export function hasPermissions() {
  return new Promise((resolve, reject) => {
    FB.fbSdk.api('me/permissions', (response) => {
      const data = response.data;

      if (data && _.isArray(data) && _.find(data, (p) => p.permission === 'manage_pages' && p.status === 'granted')) {
        resolve(true);
      } else {
        // reject(states.not_permission);
        resolve(true);
      }
    });
  });
}

function getPageToken(page_id) {
  return new Promise((resolve) => {
    FB.fbSdk.api(`${page_id}?fields=access_token`, (response) => {
      resolve(response.access_token);
    });
  });
}

function installFbTab(page_id, page_token, install_name) {
  return new Promise((resolve, reject) => {
    return FB.fbSdk.api(`${page_id}/tabs`, 'post', {
      app_id: FB_APP_ID,
      access_token: page_token,
      custom_name: install_name
    }, (resp) => {
      if (resp.success) {
        return resolve();
      }

      // throw Error(resp);
      return reject(resp.error);
    });
  });
}

function uninstallFbTab(page_id, page_token) {
  return new Promise((resolve) => {
    FB.fbSdk.api(`${page_id}/tabs/app_${FB_APP_ID}`, 'delete', { access_token: page_token }, (resp) => {
      resolve();
    });
  });
}

export async function install(fb_user, page) {
  const access_token = await getPageToken(page.id);

  try {
    await installFbTab(page.id, access_token, page.install_name)
      .catch((e) => {
        throw Error(e.message);
      });

    return facebookpagesInstall(fb_user.id, page.id, page.name);
  } catch (error) {
    throw Error(error);
  }
}

export async function uninstall(fb_user, page) {
  const access_token = await getPageToken(page.id);

  await uninstallFbTab(page.id, access_token);

  facebookpagesUninstall(fb_user.id, page.id);
}

// TODO What is access token???
export function scrape(url) {
  return FB.fbSdk.api(
    '/',
    'POST',
    {
      'scrape': 'true',
      'id': url,
      // eslint-disable-next-line
      access_token: "EAAYpH4hymjwBAESzo67JTJavwGZB77I9djkN4tDRWzNZAYN479OpVgfwVq70snZA7oWW6zrjo5e9sQzPmlBvoacekHLGLUMUC6IXLAZAp2XqkbnPrN7wmken4QNZC0FZAGGSDaAt8KfCQB8ddpUUVxCXb3U7SRVVYZD" },
    // eslint-disable-next-line
    (response) => {
      // Insert your code here
    }
  );
}

/**
 * Get pages
 */
export async function loadFbPages() {
  return await getFbPage();
}

/**
 * Get all the homepages under the currently linked facebook account
 */
function getFbPage() {
  return new Promise((resolve) => {
    const data = [];

    // Get all homepages recursively
    function getPage(url) {
      FB.fbSdk.api(url, (response) => {
        // eslint-disable-next-line prefer-spread
        data.push.apply(data, response.data);

        if (response.paging && response.paging.next) {
          getPage(response.paging.next);
        } else {
          resolve(data);
        }
      });
    }

    getPage('/me/accounts?fields=access_token,id,name,description,has_added_app');
  });
}

